import { styled } from "@mui/material/styles";
import Pagination from "@material-ui/lab/Pagination";

export const StyledPagination = styled(Pagination)({
  ".MuiButtonBase-root": {
    fontFamily: "IRANSans",
    fontSize: "var(--font-size-xl)",
    color: "var(--dark-color)",
    borderRadius: 14,
    width: 44,
    height: "44px !important",
  },
  "ul.MuiPagination-ul": {
    justifyContent: "center",
  },
  "ul.MuiPagination-ul li:first-of-type button.MuiPaginationItem-root, ul.MuiPagination-ul li:last-of-type button.MuiPaginationItem-root":
    {
      borderRadius: "50%",
      backgroundColor: "var(--blue-color-light)",
    },
  "ul.MuiPagination-ul li:first-of-type button.Mui-disabled, ul.MuiPagination-ul li:last-of-type button.Mui-disabled":
    {
      display: "none",
    },
  ".MuiPaginationItem-page.Mui-selected": {
    backgroundColor: "var(--blue-color-light)",
  },
  ".MuiPaginationItem-icon": {
    color: "var(--white-color)",
    transform: "rotate(180deg)",
    width: 30,
    height: 30,
  },
});
